import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import './style/index.less';
import 'animate.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {url,imageurl,formatime,imgurl,isWeiXin,islogin,datatoFile,userlevel,add0,getRouter,sharePopup,getPoliceType} from './utils/location.js';
import {getAjax} from './utils/getAjax.js';
// import {cityjson,areajson} from './utils/city.js';
// import {field} from './utils/fieldList.js';
import {fshare,settrack} from './utils/share.js';
import './utils/funrem.js';
import VuewechatTitle from 'vue-wechat-title'
// import Bscroll from 'better-scroll';
// import lrz from 'lrz';
import * as echarts from 'echarts';
// import 'lib-flexible/flexible';
import Router from 'vue-router';
import {getData} from './utils/client.js';
import cookie from 'vue-cookies';
axios.defaults.withCredentials=true;
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.prototype.ajaxUrl = url; //地址转换
Vue.prototype.axios=axios; //地址转换
Vue.prototype.imageurl=imageurl;//图片集合转换
Vue.prototype.$formatime=formatime;//时间转换
Vue.prototype.$add0=add0;//时间转换
Vue.prototype.$imgurl=imgurl;//图片单个转换
Vue.prototype.$userlevel=userlevel;//城市2联动
// Vue.prototype.cityjson=cityjson;//城市2联动
// Vue.prototype.areajson=areajson;//城市3联动
Vue.prototype.$getAjax=getAjax;
Vue.prototype.$getRouter=getRouter;
Vue.prototype.$share=fshare;//分享
Vue.prototype.isWeiXin=isWeiXin;//是否微信端
Vue.prototype.datatoFile=datatoFile;//图片上传的转换
// Vue.prototype.$fieldList=field;//表单元素
Vue.prototype.$echarts = echarts;
Vue.prototype.$cookie = cookie;
Vue.prototype.$getPoliceType = getPoliceType;
Vue.prototype.$getData=getData;//接口
Vue.use(VuewechatTitle);
Vue.use(ElementUI);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");